import { render, staticRenderFns } from "./privacy_email_table.vue?vue&type=template&id=230a14d0&scoped=true&"
import script from "./privacy_email_table.vue?vue&type=script&lang=js&"
export * from "./privacy_email_table.vue?vue&type=script&lang=js&"
import style0 from "./privacy_email_table.vue?vue&type=style&index=0&id=230a14d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230a14d0",
  null
  
)

export default component.exports